<template>
  <v-list-item v-if="isEnabled"
               :href="url" target="_blank">
    <v-list-item-icon>
      <v-icon>
        fal fa-fw fa-box-ballot
      </v-icon>
    </v-list-item-icon>
    <v-list-item-content>
      <v-list-item-title>
        {{ title }}
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>
<script>
import {mapGetters} from 'vuex';

/**
 * MLD-3811
 */
export default {
  name: 'feedback-menu-item',
  data() {
    return {
      showCustomHelp: false,
    }
  },
  computed: {
    ...mapGetters([
      'team',
      'user',
    ]),
    isAllergan() {
      return this.team && [194].includes(this.team.id);
    },
    isEnabled() {
      return this.isAllergan;
    },
    url() {
      if (this.isAllergan) {
        return 'https://allergannewmaorg.lightning.force.com/lightning/o/Suggestion_Opportunity__c/new';
      }
      return 'https://www.mobilelocker.com';
    },
    title() {
      return 'Suggestion Box';
    }
  },
}
</script>
